import { useToast } from 'vue-toastification'
import i18n from '../../locales/i18n'
import {
  GetObjects,
  GetObject
} from '@/api/object.js'
import {
  GetTasks
} from '@/api/task.js'

const toast = useToast()

const state = () => ({
  originalObject1s: [],
  object1s: [],
  currentObject1: undefined,
  tasks: []
})

// getters
const getters = {
}

// actions
const actions = {
  async getBaseData ({ commit }) {
    try {
      const object1sResponse = await GetObjects()
      if (object1sResponse.status === 200) {
        const objects1Data = object1sResponse.data.Objects
        for (const object1 of objects1Data) {
          object1.Hidden = false
        }

        objects1Data.sort((a, b) => {
          const generalObjects = (name) => name.startsWith('Alla/Generell')

          if (generalObjects(a.Name) && !generalObjects(b.Name)) return -1 // "Generell/Alla" goes first
          if (!generalObjects(a.Name) && generalObjects(b.Name)) return 1 // "Generell/Alla" goes first
          return a.Name.localeCompare(b.Name) // Fallback to regular alphabetical sorting
        })

        commit('setObject1s', objects1Data)
        commit('setOriginalObject1s', objects1Data)
      } else {
        toast.warning(i18n.global.t('object1Page.couldNotGetData'))
      }
    } catch (e) {
      // console.log(e)
      toast.warning(i18n.global.t('object1Page.couldNotGetData') + ' ' + e.response.data.Message)
    }
  },
  async getObjectById ({ commit }, id) {
    commit('setCurrentObject1', undefined)
    try {
      const object1Response = await GetObject(id)
      if (object1Response.status === 200 && object1Response.data.Objects.length > 0) {
        const objectData = object1Response.data.Objects[0]

        commit('setCurrentObject1', objectData)
      } else {
        toast.warning(i18n.global.t('object1Page.couldNotGetData'))
      }
    } catch (e) {
      // console.log(e)
      toast.warning(i18n.global.t('object1Page.couldNotGetData') + ' ' + e.response.data.Message)
    }
  },
  async getObject1sByCustomer ({ commit, state }, customerId) {
    try {
      const filteredObjects = state.originalObject1s.filter(obj => obj.Customer.Id === customerId)

      commit('setObject1s', filteredObjects)
    } catch (e) {
      // console.log(e)
    }
  },
  async getTasksByObject1Id ({ commit, state }, objectId) {
    try {
      const tasksResponse = await GetTasks('?filter.objectId=' + objectId)
      if (tasksResponse.status === 200) {
        const taskdata = tasksResponse.data.Tasks
        for (const task of taskdata) {
          task.hidden = false
        }
        commit('setTasks', taskdata.sort(function (a, b) { return ((a.PlanStartDate < b.PlanStartDate) ? -1 : ((a.PlanStartDate > b.PlanStartDate) ? 1 : 0)) }))
      } else {
        toast.warning(i18n.global.t('taskPage.couldNotGetData'))
      }
    } catch (e) {
      // console.log(e)
      toast.warning(i18n.global.t('taskPage.couldNotGetData') + ' ' + e.response.data.Message)
    }
  }
}

const mutations = {
  setObject1s (state, data) {
    state.object1s = data
  },
  setOriginalObject1s (state, data) {
    state.originalObject1s = data
  },
  setCurrentObject1 (state, data) {
    state.currentObject1 = data
  },
  setTasks (state, data) {
    state.tasks = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
